import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showPricing(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const section = document.getElementById("team-access")
    const dialog = this.element.closest("dialog")
    // Standalone access pages use the link's normal navigation instead.
    if (!section || !dialog) return

    event.preventDefault()
    // Let the shared modal finish its close/reset and native focus restoration first.
    dialog.addEventListener("close", () => {
      section.scrollIntoView({ block: "start" })
      section.querySelector("#business-seats").focus({ preventScroll: true })
    }, { once: true })
    dialog.close()
  }
}
